import moment from 'moment'

export const formatDate = function (value) {
  if (!value) return value
  return moment(value).format()
}
